var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 1.2a8.802 8.802 0 1 0 .002 17.602A8.802 8.802 0 0 0 12 3.198m0 7.3c.276 0 .499.223.499.499v3.76a.5.5 0 1 1-.998 0v-3.76c0-.276.223-.499.499-.499m.01-2a.5.5 0 0 1 0 .998H12a.499.499 0 1 1 0-.998z"
  })));
};
export default SvgInfo;